/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Relativehouragomany3Inputs */

const en_relativehouragomany3 = /** @type {(inputs: Relativehouragomany3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} hours ago`)
};

const pt_relativehouragomany3 = /** @type {(inputs: Relativehouragomany3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`há ${i?.n} horas`)
};

/**
* | output |
* | --- |
* | "{n} hours ago" |
*
* @param {Relativehouragomany3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const relativehouragomany3 = /** @type {((inputs: Relativehouragomany3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Relativehouragomany3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_relativehouragomany3(inputs)
	return pt_relativehouragomany3(inputs)
});
export { relativehouragomany3 as "relativeHourAgoMany" }